export default __webpack_public_path__ + "static/media/palta-animation.d811d035.gif";